import React from "react";
import { useTranslation } from "react-i18next";

import { Button } from "../shared/Button";
import { Markdown } from "../shared/Markdown";
import { Overlay } from "../shared/Overlay";

import "./SecurityWarningDialog.scss";

export const SecurityWarningDialog = () => {
  const [open, setOpen] = React.useState(true);

  const { t } = useTranslation();
  const { cancel, text, title } = t(
    "features.security.SecurityWarningDialog",
  ) as unknown as { cancel: string; text: string; title: string };

  const handleClose = () => setOpen(false);

  if (!open) {
    return null;
  }

  return (
    <>
      <Overlay onClick={handleClose} />
      <div aria-label={title} className="SecurityWarningDialog" role="dialog">
        <div className="SecurityWarningDialog-content">
          <div className="SecurityWarningDialog-header">
            <h2 className="SecurityWarningDialog-title">{title}</h2>
          </div>
          <div className="SecurityWarningDialog-body">
            <Markdown>{text}</Markdown>
          </div>
          <div className="SecurityWarningDialog-footer">
            <Button variant="action" onClick={handleClose}>
              {cancel}
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};
